// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ShoppingCartActions } from '../duck';
import { actions as CheckoutActions } from '../../new-order/CheckoutStep/duck';
import ShoppingCart from '../components/ShoppingCart/ShoppingCart';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    user: state.auth.user,
    shoppingCart: state.shoppingCart.shoppingCart,
    isFetchingShoppingCart: state.shoppingCart.isFetchingCart,
    fetchCartError: state.shoppingCart.fetchCartError,
    isDeletingItem: state.shoppingCart.isDeletingItem,
    deleteItemError: state.shoppingCart.deleteItemError,
    isEditingItem: state.shoppingCart.isEditingItem,
    editItemError: state.shoppingCart.deleteItemError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ShoppingCartActions,
    ...CheckoutActions,
    goToRedirect: (route) => push(route)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/containers/ShoppingCartContainer.js